'use client';

import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { SVT_FOCUS_RING, SVT_TRANSITION } from '@eliadmin/core/src/components/ui/svetech-shape';
import { cn } from '@eliadmin/core/src/utils/style-utils';

type SwitchProps = Omit<
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>,
  'className'
> & {
  classNames?: { wrapper: string; thumb?: string };
};

const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, SwitchProps>(
  ({ classNames, ...props }, ref) => (
    <SwitchPrimitives.Root
      className={cn(
        // SveTech colours: green when on, #c9cdc4 track when off.
        'peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent disabled:cursor-not-allowed disabled:opacity-70 data-[state=checked]:bg-[#2c7a25] data-[state=unchecked]:bg-[#c9cdc4]',
        SVT_FOCUS_RING,
        SVT_TRANSITION,
        classNames?.wrapper,
      )}
      {...props}
      ref={ref}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          'pointer-events-none block h-4 w-4 rounded-full bg-white ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0 motion-reduce:transition-none',
          classNames?.thumb,
        )}
      />
    </SwitchPrimitives.Root>
  ),
);
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
